'use strict';

class EventList {
  constructor($window, $sce, $filter, eventService, I18N) {
    this.$window = $window;
    this.$sce = $sce;
    this.$filter = $filter;
    this.eventService = eventService;
    this.I18N = I18N;
  }

  $onInit() {
    this.alert = {};
    this.upcoming = [];
    this.past = [];
    this.cancelled = [];

    this.totals = {
      paid: 0,
      confirmed: 0,
      pending: 0,
      free: 0
    };

    this.views = {
      upcoming: true,
      past: false,
      cancelled: false
    };

    this.select = (view) => {
      // set inactive all
      this.views = {
        upcoming: false,
        past: false,
        cancelled: false
      };

      // set selected active
      this.views[view] = true;
    };

    this.pagination = {
      past: {},
      cancelled: {}
    };
    this.stats = {};

    this.loadInfo();
    this.loadEvents();
    this.loadPastEvents();
    this.loadCancelledEvents();
  }

  loadInfo() {
    this.eventService.info()
      .then((resp) => {
        this.stats = resp.data;
      });
  }

  calcTotal(events) {
    if (events && events.length) {
      // reset
      this.totals = {
        paid: 0,
        confirmed: 0,
        pending: 0,
        free: 0
      };

      events.forEach((event) => {
        this.totals.paid += event._stats.participant.paid;
        this.totals.confirmed += event._stats.participant.registered;
        this.totals.pending += event._stats.participant.pending;
        this.totals.free += event.participantLimit - (event._stats.participant.registered + event._stats.participant.pending);
      }, this);
    }
  }

  loadEvents() {
    this.eventService.getEvents()
      .then((resp) => {
        if (resp.data && resp.data.length) {
          resp.data.forEach((e) => {
            e.description = this.$sce.trustAsHtml(e.description);
            return e;
          }, this);

          this.upcoming = resp.data;

          this.calcTotal(resp.data);
        }
      })
      .catch(() => {
        this.alert = {
          type: 'error',
          message: this.I18N.event.error.download
        };
      });
  }

  loadPastEvents(url, q) {
    this.eventService.getPastEvents(url, q)
      .then((resp) => {
        if (resp.headers('Link') !== null) {
          this.pagination.past = this.$filter('parseLinkHeader')(resp.headers('Link'));
        }

        this.past = resp.data;
      })
      .catch(() => {
        this.alert = {
          type: 'error',
          message: this.I18N.event.error.download
        };
      });
  }

  loadCancelledEvents(url, q) {
    this.eventService.getCancelledEvents(url, q)
      .then((resp) => {
        if (resp.headers('Link') !== null) {
          this.pagination.cancelled = this.$filter('parseLinkHeader')(resp.headers('Link'));
        }

        this.cancelled = resp.data;

        // check if there is any partially credited invoice
        if (resp.data && resp.data.length) {
          resp.data.forEach((event) => {
            this.eventService.invoiceCheck(event.number)
              .then((events) => {
                if (events.data && events.data._links) {
                  events.data._links.partiallyCredited = true;
                }
              });
          }, this);
        }
      })
      .catch(() => {
        this.alert = {
          type: 'error',
          message: this.I18N.event.error.download
        };
      });
  }

  action(url) {
    if (url) {
      this.eventService.eventAction(url)
        .then(() => {
          this.loadInfo();
          this.loadEvents();
          this.loadPastEvents();
          this.loadCancelledEvents();
        });
    } else {
      this.alert = {
        type: 'error',
        message: this.I18N.general.systemError
      };
    }
  }

  remove(url) {
    if (url) {
      swal({
        title: 'Bekreft kansellering',
        showCancelButton: true,
        confirmButtonColor: '#970b0e',
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nei',
        closeOnConfirm: false,
        showLoaderOnConfirm: true
      }, (answer) => {
        if (answer) {
          swal.close();
          this.action(url);
        }
      });
    }
  }

  removeStorage() {
    this.$window.sessionStorage.removeItem('event');
  }
}

EventList.$inject = ['$window', '$sce', '$filter', 'eventService', 'I18N'];

const eventList = {
  controller: EventList,
  templateUrl: 'event/list.html'
};

angular
  .module('SendRegning')
  .component('eventList', eventList)
  .config(($routeProvider) => {
    $routeProvider
      .when('/vert', {
        title: 'Arrangement',
        template: '<event-list />',
        secure: true
      });
  });
